import {Box, Typography} from '@mui/material';
import {ArrowLeft} from '@phosphor-icons/react';
import {messages} from '@smartmixin/i18n';
import React from 'react';
import {useIntl} from 'react-intl';
import {Button} from '../../components/ui';
import {useHelpBasePath} from '../../help-center/hooks/useHelpLocale';

type HelpNotFoundProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

/**
 * An unknown help category or article: the page's h1 in the empty-state
 * frame (dashed line.control), and the way back as a link that stays in the
 * app (it set window.location.href: a full page reload).
 */
const HelpNotFound = ({icon, title, description}: HelpNotFoundProps) => {
  const {formatMessage} = useIntl();
  const helpBasePath = useHelpBasePath();
  return (
    <Box
      data-testid="empty-state"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 1,
        py: 6,
        px: 2,
        border: '1px dashed',
        borderColor: 'border.control',
        borderRadius: 1.5,
      }}>
      <Box aria-hidden sx={{display: 'flex', color: 'text.secondary'}}>
        {icon}
      </Box>
      <Typography variant="h1" component="h1" sx={{color: 'text.primary'}}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{color: 'text.secondary', maxWidth: 400}}>
        {description}
      </Typography>
      <Button
        variant="secondary"
        href={helpBasePath}
        startIcon={<ArrowLeft aria-hidden />}
        sx={{mt: 1}}>
        {formatMessage(messages.helpCenter.backToHelpCenter)}
      </Button>
    </Box>
  );
};

export default HelpNotFound;
